<template>
    <b-modal
        id="delete-modal"
        title="Confirm Delete"
        ref="DeleteVoucher"
        @hidden="closeModal">
        <p class="modal-main-message">Are you sure you want to delete <strong>{{ modal.delete.name }}</strong>?</p>
        <b-form-group
            id="passwordConfirmationGroup"
            label="To delete this store voucher, please enter your password"
            label-for="passwordConfirmation"
            class="secondary-label mb-2"
        >
            <b-form-input
            id="passwordConfirmation"
            type="password"
            v-model="passwordConfirmation"
            required
            maxlength="25"
            ></b-form-input>
        </b-form-group>
        <div slot="modal-footer">
            <b-button variant="ghost" v-bind:disabled="loading" class="btn-cancel" style="margin-right: .25rem;" @click="closeModal">
                No
            </b-button>
            <b-button variant="primary" v-bind:disabled="loading || (passwordConfirmation == '')" style="margin-left: .25rem;" @click="deleteStoreVoucher">
                <template v-if="loading">
                    Deleting...
                </template>
                <template v-else>
                    Yes, Delete
                </template>
            </b-button>
            <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

function initialState() {
    return {
        passwordConfirmation: ""
    }
}

export default {
    name: "ConfirmDelete",
    props: ["status", "name"],
    data() {
        return initialState();
    },
    computed: {
        ...mapState("estoreVouchers", ["loading", "errors", "modal"]),
        ...mapState("purchasePackages", ["confirmationStatus"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("estoreVouchers/setModal", {
                type: "delete",
                status: false,
                uuid: null,
                name: ""
            });
        },
        deleteStoreVoucher: async function() {
            let param = {
                password: this.passwordConfirmation
            };

            let _this = this;
            await this.$store
                .dispatch("purchasePackages/confirmAction", param)
                .then(() => {
                    if (_this.confirmationStatus) {
                        this.$store.dispatch("estoreVouchers/deleteStoreVoucher", this.modal.delete.uuid).then(function() {
                            if (_this.errors == null) {
                                _this.closeModal();
                                let param = {
                                    page: 1,
                                    payload: null
                                };
                                _this.$store.dispatch("estoreVouchers/getStoreVouchers", param);
                                _this.clearFields();
                            }
                        });
                    }
                });
        },
        clearFields() {
            this.$store.dispatch("estoreVouchers/resetErrors");
            Object.assign(this.$data, initialState());
        },
    },
    watch: {
        status: function(status) {
            if (status == true) {
                this.$refs.DeleteVoucher.show();
            } else {
                this.$refs.DeleteVoucher.hide();
            }
        }
    }
};
</script>
